import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance2dx6odfkdwlsm as Data_getInstance } from './adapter/SaveBoostMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SaveBoostMutation_VariablesAdapter_instance2lm8atx218dgg as SaveBoostMutation_VariablesAdapter_instance } from './adapter/SaveBoostMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveBoost) {
        this.x6f_1 = saveBoost;
      }
      toString() {
        return 'Data(saveBoost=' + this.x6f_1 + ')';
      }
      hashCode() {
        return this.x6f_1 == null ? 0 : getBooleanHashCode(this.x6f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.x6f_1 == other.x6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.y6f_1 = 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
        this.z6f_1 = 'saveBoost';
      }
      j6e() {
        return 'mutation saveBoost($input: SaveBoostInput!) { saveBoost(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SaveBoostMutationClass;
function SaveBoostMutation() {
  if (SaveBoostMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.a6g_1 = input;
      }
      l6e() {
        return 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
      }
      operationId() {
        return this.l6e();
      }
      z47() {
        return Companion_instance.j6e();
      }
      m6e() {
        return 'saveBoost';
      }
      operationName() {
        return this.m6e();
      }
      t46(writer, customScalarAdapters, withDefaultValues) {
        SaveBoostMutation_VariablesAdapter_instance.b6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      s46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SaveBoostMutation(input=' + this.a6g_1.toString() + ')';
      }
      hashCode() {
        return this.a6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveBoostMutation()))
          return false;
        if (!this.a6g_1.equals(other.a6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveBoostMutation', VOID, VOID, [Mutation()]);
    SaveBoostMutationClass = $;
  }
  return SaveBoostMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data20ir384tdyz1e,
  SaveBoostMutation as SaveBoostMutation360x4uh5hti27,
};
//endregion

//# sourceMappingURL=SaveBoostMutation.mjs.map
